<div class="modal-header">
  <h3 class="modal-title" id="modal-title">{{title}}</h3>
</div>
<div class="modal-body" id="modal-body">
  <div class="alert alert-danger" *ngIf="errorMessage">{{errorMessage}}</div>
  {{text}}
  <div class="form-group" *ngIf="type === types.YesNoComment">
      <label>Komentar:</label>
      <textarea class="form-control" [(ngModel)]="comment"></textarea>
  </div>
</div>

<div class="modal-footer">
    <button class="btn btn-primary" type="button" (click)="ok()">{{okText}}</button>
    <button class="btn btn-default" type="button" (click)="cancel()" *ngIf="type == types.Yesno">{{cancelText}}</button>
</div>
